module.exports = __webpack_public_path__ + "img/img_teacher3.343300ce.png";